<template>
	<div>
		<integracoes
			:data="myData"
			:loadingtable="isLoading"
			:total-pages="totalPages"
			:currentpage="currentpage"
			@update-table="getFilterData($event)"
			@search-text="getFilterData($event)"
			@pagechange="getFilterData($event)"
			@apply-modal="getFilterData($event)"
		/>
	</div>
</template>

<script>
import integracoes from '../../layout/components/table/integracoes';
import * as ecAxios from '../../util/ecAxios';
import global from '../../mixins/global';

export default {
	components: {
		integracoes,
	},
	mixins: [global],
	data() {
		return {
			data: [],
			isLoading: true,
			limit: 10,
			offset: 0,
			mytotalPages: 0,
			pagenumber: 0,
			totalPages: 0,
			currentpage: 1,
		};
	},
	computed: {
		myData() {
			return this.data;
		},
	},
	methods: {
		async getAllData() {
			this.isLoading = true;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_SINCRONIZACAO_PACOTE}`, {
					direction: 'desc',
					// limit: 50,
					offset: 0,
					orderby: 'dtinicio',
					searchTerm: '',
				})
				.then((response) => {
					if (response.data.error === 0) {
						this.totalPages = response.data.count;
						this.data = response.data.sincronizacaoPacotes;
						const newData = [];
						this.data.map((item) => {
							// eslint-disable-next-line no-param-reassign
							item.dtinicio = this.dateTimeToBrasil(item.dtinicio);
							// eslint-disable-next-line no-param-reassign
							item.dtfim = this.dateTimeToBrasil(item.dtfim);
							newData.push(item);
							return true;
						});
						this.data = newData;
						this.isLoading = false;
					}
				});
		},
		async getFilterData(pagination) {
			this.isLoading = true;
			const data = JSON.parse(localStorage.getItem('filter-integracoes'));
			this.currentpage = pagination.page;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_SINCRONIZACAO_PACOTE}`, {
					...data,
					limit: pagination.limit,
					offset: pagination.offset,
				})
				.then((response) => {
					if (response.data.error === 0) {
						this.totalPages = response.data.count;
						this.data = response.data.sincronizacaoPacotes;
						this.isLoading = false;
					}
				});
		},
	},
};
</script>

<style></style>

